import { useCallback } from 'react';

import { type ConnectorRunningStatus } from '@/entities/connector';

import { useDeleteConnectors } from './useDeleteConnector';
import { useUpdateConnectorsStatus } from './useUpdateConnectorStatus';

export const useConnectorActions = () => {
  const { mutateAsync: deleteConnectors, isPending: isDeletePending } = useDeleteConnectors();
  const { mutateAsync: updateConnectorsStatus, isPending: isStatusPending } = useUpdateConnectorsStatus();

  const isMutationPending = isDeletePending || isStatusPending;

  const handleDeleteConfirm = useCallback(
    async (ids: string[]) => {
      if (ids.length === 0) return;
      await deleteConnectors({ ids });
    },
    [deleteConnectors]
  );

  const handleStatusChange = useCallback(
    async (ids: string[], status: ConnectorRunningStatus) => {
      if (ids.length === 0) return;
      await updateConnectorsStatus({ ids, status });
    },
    [updateConnectorsStatus]
  );

  return {
    isDeletePending,
    isStatusPending,
    isMutationPending,
    handleDeleteConfirm,
    handleStatusChange,
  } as const;
};
